<ion-row>
    <ion-col size="12">
        <h1 class="bundle-title ion-text-center">
            {{ details?.bundleTitle }}
        </h1>
    </ion-col>
    <ion-col size="12">
        <div class="bundle-card">
            <div class="header">
                <div class="header-content ion-text-center header-content-programs-info">
                    <h2 class="bundle-section-title">
                        Choose up to
                        {{ details?.programs?.length | numberToWords }}
                        programs.
                    </h2>
                    <section *ngIf="!noDiscountDescription">
                        <b> The more programs you choose, the more you save. </b>
                        <p>
                            You can choose to participate in the rotations in any order, at any time that works for you.
                            <span *ngFor="let coupon of details?.bundleDiscounts">
                                Select and reserve
                                {{ coupon.count | numberToWords }} programs at the same time and receive a total discount of ${{ coupon.discount }}.
                            </span>
                        </p>
                    </section>
                    <section *ngIf="noDiscountDescription">
                        {{ details?.bundleDescription }}
                    </section>
                </div>
            </div>
            <div class="ion-padding-bottom">
                <div>
                    <swiper-container
                        [pagination]="{ clickable: true }"
                        [slidesPerView]="slideOpts.slidesPerView"
                        [initialSlide]="slideOpts.initialSlide"
                        [speed]="slideOpts.speed"
                        [allowSlideNext]="slideOpts.allowSlideNext"
                        [allowSlidePrev]="slideOpts.allowSlidePrev"
                        [breakpoints]="slideOpts.breakpoints"
                        #mySlider
                        (swiperslidechange)="slideChanged()"
                        style="height: 51em"
                    >
                        <swiper-slide class="slide-program" *ngFor="let program of testData; let i = index">
                            <app-program-bundle-cards
                                [program]="program"
                                [user]="details?.profile"
                                [selected]="selectedProgram === testData[i]"
                                (onFormGroupChange)="onFormGroupChangeEvent($event)"
                                (formInvalidMarker)="gettingInvalidMarker($event)"
                                [index]="i"
                            >
                            </app-program-bundle-cards>
                        </swiper-slide>
                    </swiper-container>
                    <div class="swiper-buttons" [ngClass]="{ 'dont-display': testData.length <= 2 }">
                        <div class="swiper-button-prev arrow-btn" (click)="leftClick()" *ngIf="sliderPositionState !== 'start'"></div>
                        <div class="swiper-button-next arrow-btn" (click)="rightClick()" *ngIf="sliderPositionState !== 'end'"></div>
                    </div>
                </div>
                <div class="footer ion-text-center ion-margin-bottom">
                    <div class="footer-content">
                        <div class="footer-margin-bottom">
                            <ion-text color="primary">
                                <p>Please select at least two experiences from this bundle to apply.</p>
                            </ion-text>
                        </div>
                        <div class="discount-container" *ngIf="totalDiscount">
                            <p class="discount-label ion-no-margin">Total Discount:</p>
                            <p class="discount-amount">${{ totalDiscount }} USD!</p>
                        </div>
                        <ion-button fill="solid" color="primary" class="footer-button" (click)="submit()" disabled="true">
                            <!-- [disabled]="bundledApplyProgram.length <= 1 || bundleSubmitted || !(USER_ID$ | async)" -->
                            Apply Now!
                        </ion-button>
                    </div>
                </div>
            </div>
        </div>
    </ion-col>
</ion-row>
